var Isometric = function () {

    var getSequenceOptions = function () {
        // <a href="#1" class="seq-1 png-sequence" rel="02" data-seq="29"></a>
        // <a href="#2" class="seq-3 png-sequence" rel="05" data-seq="29"></a>
        // <a href="#3" class="seq-4 png-sequence" rel="04" data-seq="29"></a>
        // <a href="#4" class="seq-5 png-sequence" rel="03" data-seq="29"></a>
        // <a href="#5" class="seq-6 png-sequence" rel="07" data-seq="59"></a>
        // <a href="#6" class="seq-7 png-sequence" rel="06" data-seq="29"></a>
        return [
            {
                class: "seq-1",
                dirName: "02",
                dirImagesCount: 29
            },
            {
                class: "seq-3",
                dirName: "05",
                dirImagesCount: 29
            },
            {
                class: "seq-4",
                dirName: "04",
                dirImagesCount: 29
            },
            {
                class: "seq-5",
                dirName: "03",
                dirImagesCount: 29
            },
            {
                class: "seq-6",
                dirName: "07",
                dirImagesCount: 59
            },
            {
                class: "seq-7",
                dirName: "06",
                dirImagesCount: 29
            },
        ];
    };

    var initSequences = function () {
        var sequenceOptions = getSequenceOptions();

        $('.png-sequence').each(function (index) {
            var sequence = sequenceOptions[index];

            $(this).addClass(sequence.class);
            $(this).attr('rel', sequence.dirName);
            $(this).attr('data-seq', sequence.dirImagesCount);

            for (var i = 0; i <= sequence.dirImagesCount; i++) {
                var delay = index + 1;
                $(this).append('<img class="fadeIn animated delay-' + delay + 's" src="/images/png_seq/' + sequence.dirName + '/' + sequence.dirName + '_' + $.strPad(i, 5, '0', 'STR_PAD_LEFT') + '.png"/>');
            }
        });
    };

    var initSmallScreenFunctionalities = function () {
        $('.png-sequence').click(function () {
            var seqObj = $(this);
            var slug = seqObj.data('slug');

            $('.seq-cont.active').removeClass('active');

            setTimeout(() => {
                $('#' + slug).addClass('active');
            }, 100);
        });
    };

    var initLargeScreenFunctionalities = function (seqObj) {

        var slug = seqObj.data('slug');

        var itemContent = $('#' + slug);

        if (itemContent.hasClass('active')) {
            return;
        }

        $('.seq-cont.active').removeClass('active');

        setTimeout(() => {
            itemContent.addClass('active');
        }, 100);
    };

    var initIsometricMap = function () {

        var seqTimer, seqAnimTimer, seqObj, seqObjImg = null;
        var seqCounter = [0, 0, 0, 0, 0, 0, 0, 0];


        $('.png-sequence').mouseenter(function () {
            seqObj = $(this);
            _seq_animate();

        });

        if ($(window).width() > 1204) {

            window.addEventListener('scroll', function (e) {
                $('.seq-cont.active').removeClass('active');

            });

            $('.png-sequence').click(function (e) {
                e.preventDefault();
                initLargeScreenFunctionalities($(this));
            });

        }


        $('.png-sequence').mouseleave(function () {
            clearTimeout(seqTimer);
            _seq_animate_stop();
            $('.png-sequence.progress').removeClass('progress');
            $('.png-sequence.loaded').removeClass('loaded');
        });

        if ($(window).width() <= 1204) {
            initSmallScreenFunctionalities();
        }


        function _seq_animate() {
            var $max_seq = parseInt($(seqObj).data('seq'));
            var $dir = $(seqObj).attr('rel');
            var $index = parseInt($dir);

            if (seqCounter[$index] > $max_seq) seqCounter[$index] = 0;

            $('img', seqObj).css('visibility', 'hidden');
            $('img', seqObj).eq(seqCounter[$index]).css('visibility', 'visible');

            seqObjImg = $('img', seqObj).eq(seqCounter);
            seqCounter[$index] += 1;
            seqAnimTimer = setTimeout(function () { _seq_animate(); }, 100);
        }

        function _seq_animate_stop() {
            //seqCounter = 0;
            clearTimeout(seqAnimTimer);
        }

    };


    return {
        //main function to initiate the module
        init: function () {
            initSequences();
            initIsometricMap();
        }
    };
}();

$(document).ready(function () {
    if ($('.png-sequence').length) {
        Isometric.init();
    }
});




